<template>
  <div></div>
</template>
<script>

  import Pusher from "../../helpers/PusherManager"

  import WeightApi from "../../api/Tracking/Weight"

  export default {
    name: 'tracking-notifier',
    model() {
      return {
        pusher: undefined
      }
    },
    props: {
      userId: {
        type: Number
      }
    },
    mounted: function mounted() {
      let self = this;
      self.pusher = Pusher.subscribe('tracking_' + self.userId);

      self.pusher.bind('onActivityChanged', function (model) {
        self.$store.commit('setActivityCard', model);
        self.$EventBus.$emit('activityPusherReceived', model);
        if (self.$route.name === "ActivityProgress") {
          self.$EventBus.$emit('updateGraphData');
        }
      });

      self.pusher.bind('onKetonesChanged', function (model) {
        self.$store.commit('setKetonesCard', model);
        self.$EventBus.$emit('ketonesPusherReceived', model);
        if (self.$route.name === "KetonesProgress") {
          self.$EventBus.$emit('updateGraphData');
        }
      });

      self.pusher.bind('onCholesterolChanged', function (model) {
        self.$store.commit('setCholesterolCard', model);
        self.$EventBus.$emit('cholesterolPusherReceived', model);
        if (self.$route.name === "CholesterolProgress") {
          self.$EventBus.$emit('updateGraphData');
        }
      });

      self.pusher.bind('onMoodChanged', function (model) {
        self.$store.commit('setMoodCard', model);
        self.$EventBus.$emit('moodPusherReceived', model);
        if (self.$route.name === "MoodProgress") {
          self.$EventBus.$emit('updateGraphData');
        }
      });

      self.pusher.bind('onInsulinChanged', function (model) {
        self.$store.commit('setInsulinCard', model);
        self.$EventBus.$emit('insulinPusherReceived', model);
        if (self.$route.name === "InsulinProgress") {
          self.$EventBus.$emit('updateGraphData');
        }
      });

      self.pusher.bind('onSleepChanged', function (model) {
        self.$store.commit('setSleepCard', model);
        self.$EventBus.$emit('sleepPusherReceived', model);
        if (self.$route.name === "SleepProgress") {
          self.$EventBus.$emit('updateGraphData');
        }
      });

      self.pusher.bind('onWeightChanged', function (model) {
        self.$store.commit('setWeightCard', model);
        self.$EventBus.$emit('weightPusherReceived', model);
        if (self.$route.name === "WeightProgress") {
          self.$EventBus.$emit('updateGraphData');
        }
      });

      self.pusher.bind('onBloodGlucoseChanged', function (model) {
        self.$store.commit('setBloodGlucoseCard', model);
        self.$EventBus.$emit('bgPusherReceived', model);
        if (self.$route.name === "BloodGlucoseProgress") {
          self.$EventBus.$emit('updateGraphData');
        }
      });

      self.pusher.bind('onMedicationChanged', function (model) {
        self.$store.commit('setMedicationCard', model);
        self.$EventBus.$emit('medicationPusherReceived', model);
        if (self.$route.name === "MedicationProgress") {
          self.$EventBus.$emit('updateGraphData');
        }
      });

      self.pusher.bind('onBloodPressureChanged', function (model) {
        self.$store.commit('setBloodPressureCard', model);
        self.$EventBus.$emit('bloodPressurePusherReceived', model);
        if (self.$route.name === "BloodPressureProgress") {
          self.$EventBus.$emit('updateGraphData');
        }
      });
    },
    beforeDestroy() {
      let self = this;
      self.pusher.unbind_all();
    }
  }
</script>



// WEBPACK FOOTER //
// TrackingNotifier.vue?603fc71d